module.exports = __webpack_public_path__ + "static/front-page-02-42767172d8bca9a918e29343e3aac985.jpg";